export const getSessionHash = store => store.public_session_hash?.data;
